module.exports = __webpack_public_path__ + "static/media/gabriela_mesnita.23b30f19.png";